/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    '输入至少 {minimumLength} 个字符或数字，以搜索所有 {sourceName} 记录。',
  [HintsType.noFilterOrSearchRecordsTitle]: '找不到结果',
  [HintsType.noFilterOrSearchRecordsContent]:
    '查看来自其他来源的结果或更改您的关键字。',
  [HintsType.searching]: '正在搜索…',
  companyTabTitle: '公司',
  personalTabTitle: '个人',
  direct: '直拨',
  extension: '分机',
  contact: '联系人',
  mobile: '手机',
  company: '公司',
  home: '住宅',
  home2: '住宅',
  other: '其他',
  business: '商务',
  business2: '商务',
  car: '汽车',
  fax: '传真',
  assistant: '助手',
  callback: '回拨',
  MobileNumber: '手机号码',
  ContactNumber: '联系电话',
  DirectNumber: '直拨号码',
  doNotCall: '谢绝来电',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
